module.exports = __webpack_public_path__ + "img/gsb34.49755f6f.png";